import { removeToken } from "../actions/localstore";
import { logAuthEventOnExpiry } from "../actions/authSessionTracker";

export const getToken = () => {
  const token = sessionStorage.getItem("userToken");
  return token;
};

export const isAuthenticated = () => {
  const token = sessionStorage.getItem("userToken");
  const expiryTime = sessionStorage.getItem("tokenExpiry");

  if (!token || !expiryTime) {
    return false;
  }

  if (Date.now() > parseInt(expiryTime, 10)) {
    logAuthEventOnExpiry({
      user: {
        _id: sessionStorage.getItem("userId") || "",
        email: sessionStorage.getItem("userEmail") || "",
        name: sessionStorage.getItem("userName") || "",
      },
      source: "token_expired",
    });
    removeToken();
    sessionStorage.removeItem("userEmail");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("userId");
    return false;
  }

  return true;
};

// Fallback to hard-coded values for development if environment variables are not set
export const base_url = process.env.REACT_APP_BASE_URL;
export const email_server_url = process.env.REACT_APP_BASE_URL_EMAIL_SERVER;
